import React from 'react';

export interface LivePreviewFrameProps {
  files: Record<string, string>;
  supabaseUrl: string;
  supabaseAnonKey: string;
  previewMode: boolean;
  projectId?: string;
  apiUrl?: string;
  previewReviewLevel?: number;
  previewTaskId?: string;
  className?: string;
}

/**
 * Renders generated single-file HTML/CSS/JS inside an iframe with runtime config injected.
 * - Injects window.__CONFIG__ with Supabase details and preview flags
 * - Replaces %SUPABASE_URL% and %SUPABASE_ANON_KEY% placeholders if present
 */
const LivePreviewFrame: React.FC<LivePreviewFrameProps> = ({
  files,
  supabaseUrl,
  supabaseAnonKey,
  previewMode,
  projectId,
  className,
  apiUrl,
  previewReviewLevel,
  previewTaskId,
}) => {
  const srcDoc = React.useMemo(() => {
    const html = files['index.html'] || '<!doctype html><html><body><pre>No index.html</pre></body></html>';
    const cfg = {
      VITE_SUPABASE_URL: supabaseUrl,
      VITE_SUPABASE_ANON_KEY: supabaseAnonKey,
      PREVIEW_MODE: previewMode,
      PROJECT_ID: projectId,
      API_URL: apiUrl || (typeof window !== 'undefined' ? window.location.origin : ''),
      PREVIEW_REVIEW_LEVEL: typeof previewReviewLevel === 'number' ? previewReviewLevel : undefined,
      PREVIEW_TASK_ID: typeof previewTaskId === 'string' && previewTaskId.length > 0
        ? previewTaskId
        : ((typeof window !== 'undefined' && (window as any).__PREVIEW_TASK_ID__) || undefined),
    } as const;
    const configScript = `<script>window.__CONFIG__=${JSON.stringify(cfg)};<\/script>`;
    return html
      .replace('%SUPABASE_URL%', supabaseUrl)
      .replace('%SUPABASE_ANON_KEY%', supabaseAnonKey)
      .replace('</head>', `${configScript}</head>`);
  }, [files, supabaseUrl, supabaseAnonKey, previewMode, projectId, previewReviewLevel, previewTaskId, apiUrl]);

  return (
    <iframe
      title="Live Preview"
      className={className}
      style={{ width: '100%', height: '100%', border: 0 }}
      srcDoc={srcDoc}
    />
  );
};

export default LivePreviewFrame;


